// İhale modülü hesap yardımcıları (form, liste, export ortak kullanır)

// "39.520.000,00 TL" → 39520000.00. Negatifleri korur. Boş ise 0.
export const cleanMoney = (val) => {
  if (val === null || val === undefined || val === '') return 0;
  const cleaned = val.toString().replace(/[^0-9,.\-]/g, '').replace(/\./g, '').replace(',', '.');
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};

// En son güncel sözleşme bedeli: guncel_3 → guncel_2 → guncel_1 → legacy guncel → sozlesme_bedeli
export const getSonGuncelSozlesme = (ihale) => {
  if (!ihale) return 0;
  const candidates = [
    ihale.guncel_sozlesme_bedeli_3,
    ihale.guncel_sozlesme_bedeli_2,
    ihale.guncel_sozlesme_bedeli_1,
    ihale.guncel_sozlesme_bedeli,
    ihale.sozlesme_bedeli,
  ];
  for (const c of candidates) {
    const n = cleanMoney(c);
    if (n > 0) return n;
  }
  return 0;
};

// Nakdi ilerleme yüzdesi (live hesaplama).
// Formül: Toplam Ödenen Hakediş (KDV Dahil) / (Son Güncel Sözleşme Bedeli × 1.20) × 100
// Sözleşme bedeli KDV hariç tutulduğu için 1.20 ile çarpıp aynı vergi tabanına çekiyoruz.
export const computeNakdiIlerleme = (ihale) => {
  const hakedis = cleanMoney(ihale?.toplam_odenen_hakedis);
  const sonGuncel = getSonGuncelSozlesme(ihale);
  if (sonGuncel <= 0 || hakedis <= 0) return '';
  const pct = (hakedis / (sonGuncel * 1.20)) * 100;
  return pct.toFixed(2).replace('.', ',');
};

// Eski kayıtlar (tekil is_artis_tutari / guncel_sozlesme_bedeli) → 1. İş Artışı alanlarına taşınır
export const migrateLegacyIhale = (ihale) => {
  if (!ihale || !ihale.is_artis_tutari || ihale.is_artis_tutari_1) return ihale;
  const artis = cleanMoney(ihale.is_artis_tutari);
  const base = cleanMoney(ihale.sozlesme_bedeli);
  const oran = ihale.is_artis_orani || (base > 0 ? ((artis / base) * 100).toFixed(2).replace('.', ',') : '');
  const guncel = ihale.guncel_sozlesme_bedeli || (base > 0 ? (base + artis).toFixed(2).replace('.', ',') : '');
  return { ...ihale, is_artisi_1_var_mi: 'var', is_artis_tutari_1: ihale.is_artis_tutari, is_artis_orani_1: oran, guncel_sozlesme_bedeli_1: guncel };
};

// 1+2+3 iş artış oranlarının toplamı → "12,50" veya ''
export const toplamIsArtisOrani = (ihale) => {
  const toplam = [1, 2, 3].reduce((s, i) => s + (parseFloat(String(ihale?.[`is_artis_orani_${i}`] || '0').replace(',', '.')) || 0), 0);
  return toplam !== 0 ? toplam.toFixed(2).replace('.', ',') : '';
};
